var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "flex items-center justify-center enter-error-container" },
      [
        _c(
          "div",
          {
            staticClass:
              "enter-error-wrapper border-2 items-center justify-center",
          },
          [
            _vm._m(0),
            _c(
              "button",
              {
                staticClass: "btn-logout",
                attrs: { type: "button" },
                on: { click: _vm.onLogout },
              },
              [_c("span", [_vm._v("확인")])]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex-col text-center" }, [
      _c("p", { staticClass: "font-bold text-2xl" }, [
        _vm._v("인증 정보가 만료되었습니다."),
      ]),
      _c("p", [
        _vm._v("확인 버튼을 누르면 기존 인증(로그인, OTP)정보가 삭제됩니다."),
      ]),
      _c("p", [_vm._v("인증(로그인, OTP)정보 후 다시 입장 해주세요.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }